const DEVELOPMENT = 'development';
const HOMOLOG = 'homolog';
const PRODUCTION = 'production';
// Deploy de preview (manual-deploy-backoffice.yml injeta REACT_APP_STAGE=preview);
// sem o membro aqui, config.stage cairia em DEVELOPMENT silenciosamente.
const PREVIEW = 'preview';

const AppStage = {
  DEVELOPMENT,
  HOMOLOG,
  PRODUCTION,
  PREVIEW,
  ALL: [DEVELOPMENT, HOMOLOG, PRODUCTION, PREVIEW],
};

export default AppStage;
